<template>
  <div class="cases-part2">
    <div class="cases-part2-box">
      <div class="container">
        <div class="row">
          <div class="title">{{ $t("header.Projectsunderconstruction") }}</div>
          <div class="col-12">
            <p class="title-p">
              {{ $t("cases.cases_11") }}
            </p>
          </div>
          <div class="col-12">
            <div class="map-img">
              <img
                src="../../assets/image/cases-map.png"
                class="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-3 location-container">
            <div class="location-box">
              <div
                class="location-item"
                v-for="(item, index) in locationList"
                :key="index"
                :class="[item.isActive ? 'active' : '']"
                @click="changeCity(index)"
              >
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-8 col-9 offset-md-2 detail-container">
            <div class="location-detail">
              <div class="detail-title">
                <div class="title-left">{{$t('contact.projectName')}}</div>
                <div class="title-right">{{$t('contact.projectAddress')}}</div>
              </div>

              <ul class="detail-list">
                <li
                  class="detail-list-item"
                  v-for="(item, index) in proList"
                  :key="index"
                >
                  <div class="detail-left">
                    <span>{{ index + 1 }}</span>
                    <p>{{ item.name }}</p>
                  </div>
                  <div class="detail-right">
                    <p>{{ item.address }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { log } from "util";
export default {
  components: {},
  props: {},
  data() {
    return {
      cityIndex: "",
      locationList: [
        {
          id: 1,
          title: this.$t("project.address1"),
          isActive: true,
          isshow: true,
        },
        {
          id: 2,
          title: this.$t("project.address2"),
          isActive: false,
          isshow: false,
        },
        {
          id: 3,
          title: this.$t("project.address3"),
          isActive: false,
          isshow: false,
        },
        {
          id: 4,
          title: this.$t("project.address4"),
          isActive: false,
          isshow: false,
        },
        {
          id: 5,
          title: this.$t("project.address5"),
          isActive: false,
          isshow: false,
        },
        {
          id: 6,
          title: this.$t("project.address6"),
          isActive: false,
          isshow: false,
        },
        {
          id: 7,
          title: this.$t("project.address7"),
          isActive: false,
          isshow: false,
        },
        {
          id: 8,
          title: this.$t("project.address8"),
          isActive: false,
          isshow: false,
        },
        {
          id: 9,
          title: this.$t("project.address9"),
          isActive: false,
          isshow: false,
        },
        {
          id: 10,
          title: this.$t("project.address10"),
          isActive: false,
          isshow: false,
        },
        {
          id: 11,
          title: this.$t("project.address11"),
          isActive: false,
          isshow: false,
        },
        {
          id: 12,
          title: this.$t("project.address12"),
          isActive: false,
          isshow: false,
        },
        {
          id: 13,
          title: this.$t("project.address13"),
          isActive: false,
          isshow: false,
        },
        {
          id: 14,
          title: this.$t("project.address14"),
          isActive: false,
          isshow: false,
        },
        {
          id: 15,
          title: this.$t("project.address15"),
          isActive: false,
          isshow: false,
        },
      ],
      proList: [
        { name: this.$t("project.p1_1"), address: this.$t("project.p1_5") },
        { name: this.$t("project.p1_2"), address: this.$t("project.p1_6") },
        { name: this.$t("project.p1_3"), address: this.$t("project.p1_7") },
        { name: this.$t("project.p1_4"), address: this.$t("project.p1_8") },
        
      ],
      proList1: [
        { name: this.$t("project.p1_1"), address: this.$t("project.p1_5") },
        { name: this.$t("project.p1_2"), address: this.$t("project.p1_6") },
        { name: this.$t("project.p1_3"), address: this.$t("project.p1_7") },
        { name: this.$t("project.p1_4"), address: this.$t("project.p1_8") },
      ],
      proList2: [
        { name: this.$t("project.p2_1"), address: this.$t("project.p2_20") },
        { name: this.$t("project.p2_2"), address: this.$t("project.p2_21") },
        { name: this.$t("project.p2_3"), address: this.$t("project.p2_22") },
        { name: this.$t("project.p2_4"), address: this.$t("project.p2_23") },
        { name: this.$t("project.p2_5"), address: this.$t("project.p2_24") },
        { name: this.$t("project.p2_6"), address: this.$t("project.p2_24") },
        { name: this.$t("project.p2_7"), address: this.$t("project.p2_25") },
        { name: this.$t("project.p2_8"), address: this.$t("project.p2_26") },
        { name: this.$t("project.p2_9"), address: this.$t("project.p2_27") },
        { name: this.$t("project.p2_10"), address: this.$t("project.p2_28") },
        { name: this.$t("project.p2_11"), address: this.$t("project.p2_29") },
        { name: this.$t("project.p2_12"), address: this.$t("project.p2_30") },
        { name: this.$t("project.p2_13"), address: this.$t("project.p2_31") },
        { name: this.$t("project.p2_14"), address: this.$t("project.p2_32") },
        { name: this.$t("project.p2_15"), address: this.$t("project.p2_32") },
        { name: this.$t("project.p2_16"), address: this.$t("project.p2_33") },
        { name: this.$t("project.p2_17"), address: this.$t("project.p2_34") },
        { name: this.$t("project.p2_18"), address: this.$t("project.p2_35") },
        { name: this.$t("project.p2_19"), address: this.$t("project.p2_36") },
      ],
      proList3: [
        { name: this.$t("project.p3_1"), address: this.$t("project.p3_9") },
        { name: this.$t("project.p3_2"), address: this.$t("project.p3_10") },
        { name: this.$t("project.p3_3"), address: this.$t("project.p3_11") },
        { name: this.$t("project.p3_4"), address: this.$t("project.p3_12") },
        { name: this.$t("project.p3_5"), address: this.$t("project.p3_13") },
        { name: this.$t("project.p3_6"), address: this.$t("project.p3_14") },
        { name: this.$t("project.p3_7"), address: this.$t("project.p3_15") },
        { name: this.$t("project.p3_8"), address: this.$t("project.p3_16") },
      ],
      proList4: [
        { name: this.$t("project.p4_1"), address: this.$t("project.p4_4") },
        { name: this.$t("project.p4_2"), address: this.$t("project.p4_5") },
        { name: this.$t("project.p4_3"), address: this.$t("project.p4_6") },
      ],
      proList5: [
        { name: this.$t("project.p5_1"), address: this.$t("project.p5_2") },
      ],
      proList6: [
        { name: this.$t("project.p6_1"), address: this.$t("project.p6_2") },
      ],
      proList7: [
        { name: this.$t("project.p7_1"), address: this.$t("project.p7_21") },
        { name: this.$t("project.p7_2"), address: this.$t("project.p7_22") },
        { name: this.$t("project.p7_3"), address: this.$t("project.p7_23") },
        { name: this.$t("project.p7_4"), address: this.$t("project.p7_24") },
        { name: this.$t("project.p7_5"), address: this.$t("project.p7_25") },
        { name: this.$t("project.p7_6"), address: this.$t("project.p7_26") },
        { name: this.$t("project.p7_7"), address: this.$t("project.p7_27") },
        { name: this.$t("project.p7_8"), address: this.$t("project.p7_28") },
        { name: this.$t("project.p7_9"), address: this.$t("project.p7_27") },
        { name: this.$t("project.p7_10"), address: this.$t("project.p7_27") },
        { name: this.$t("project.p7_11"), address: this.$t("project.p7_30") },
        { name: this.$t("project.p7_12"), address: this.$t("project.p7_31") },
        { name: this.$t("project.p7_13"), address: this.$t("project.p7_32") },
        { name: this.$t("project.p7_14"), address: this.$t("project.p7_33") },
        { name: this.$t("project.p7_15"), address: this.$t("project.p7_34") },
        { name: this.$t("project.p7_16"), address: this.$t("project.p7_35") },
        { name: this.$t("project.p7_17"), address: this.$t("project.p7_36") },
        { name: this.$t("project.p7_18"), address: this.$t("project.p7_37") },
        { name: this.$t("project.p7_19"), address: this.$t("project.p7_38") },
        { name: this.$t("project.p7_20"), address: this.$t("project.p7_39") },
      ],
      proList8: [
        { name: this.$t("project.p8_1"), address: this.$t("project.p8_6") },
        { name: this.$t("project.p8_2"), address: this.$t("project.p8_7") },
        { name: this.$t("project.p8_3"), address: this.$t("project.p8_8") },
        { name: this.$t("project.p8_4"), address: this.$t("project.p8_9") },
        { name: this.$t("project.p8_5"), address: this.$t("project.p8_10") },
      ],
      proList9: [
        { name: this.$t("project.p9_1"), address: this.$t("project.p9_4") },
        { name: this.$t("project.p9_2"), address: this.$t("project.p9_5") },
        { name: this.$t("project.p9_3"), address: this.$t("project.p9_6") },
      ],
      proList10: [
        { name: this.$t("project.p10_1"), address: this.$t("project.p10_3") },
        { name: this.$t("project.p10_2"), address: this.$t("project.p10_3") },
      ],
      proList11: [
        { name: this.$t("project.p11_1"), address: this.$t("project.p11_3") },
        { name: this.$t("project.p11_2"), address: this.$t("project.p11_4") },
      ],
      proList12: [
        { name: this.$t("project.p12_1"), address: this.$t("project.p12_2") },
      ],
      proList13: [
        { name: this.$t("project.p13_1"), address: this.$t("project.p13_2") },
      ],
      proList14: [
        { name: this.$t("project.p14_1"), address: this.$t("project.p14_2") },
      ],
      proList15: [
        { name: this.$t("project.p15_1"), address: this.$t("project.p15_2") },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    changeCity(index) {
      this.cityIndex = index + 1;
      this.locationList.forEach((item) => {
        console.log(item.id);
        item.isActive = false;
        if (this.cityIndex == item.id) {
          item.isActive = true;
        }
        switch (this.cityIndex) {
          case 1:
            this.proList = this.proList1;
            break;
          case 2:
            this.proList = this.proList2;
            break;
          case 3:
            this.proList = this.proList3;
            break;
          case 4:
            this.proList = this.proList4;
            break;
          case 5:
            this.proList = this.proList5;
            break;
          case 6:
            this.proList = this.proList6;
            break;
          case 7:
            this.proList = this.proList7;
            break;
          case 8:
            this.proList = this.proList8;
            break;
          case 9:
            this.proList = this.proList9;
            break;
          case 10:
            this.proList = this.proList10;
            break;
          case 11:
            this.proList = this.proList11;
            break;
          case 12:
            this.proList = this.proList12;
            break;
          case 13:
            this.proList = this.proList13;
            break;
          case 14:
            this.proList = this.proList14;
            break;
          case 15:
            this.proList = this.proList15;
            break;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.cases-part2 {
  background: #ffffff;
}
.title {
  background: url("../../assets/image/cases-part2-1.png") no-repeat;
  background-position: center;
  background-size: contain;
  font-size: 30px;
  font-weight: 800;
  font-style: italic;
  color: #054ea4;
  text-align: center;
  margin: 100px 0 50px 0;
  width: 100%;
}
.cases-part2-box {
  .title-p {
    font-size: 16px;
    color: #343434;
    margin-bottom: 50px;
    text-align: center;
  }
}
.location-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 50px 0;
  &::after {
    display: block;
    content: "";
    width: 12%;
  }
  .location-item {
    width: 12%;
    text-align: center;
    height: 38px;
    background: #f5f5f5;
    border-radius: 6px;
    line-height: 38px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .active {
    background: #064ea4;
    box-shadow: 0px 0px 10px 0px rgba(6, 78, 164, 0.2);
    span {
      color: #ffffff;
    }
  }
}
.location-detail {
  margin-bottom: 100px;
  .detail-title {
    display: flex;
    height: 50px;
    line-height: 50px;
  }
  .title-left {
    width: 50%;
    border-right: 2px solid #ffffff;
    background: #dedede;
    padding-left: 80px;
    font-size: 18px;
    color: #343434;
  }
  .title-right {
    width: 50%;
    padding-left: 40px;
    background: #dedede;
    font-size: 18px;
    color: #343434;
  }
}
.detail-list {
  border: 2px solid #dedede;

  li:nth-child(2n) {
    background-color: #f5f5f5;
  }
  .detail-list-item {
    display: flex;

    line-height: 44px;
    p {
      line-height: 44px;
      font-size: 14px;
      margin-bottom: 0;
    }
    span {
      display: inline-block;
      width: 80px;
      text-align: center;
    }
  }
  .detail-left {
    width: 50%;
    display: flex;
  }
  .detail-right {
    width: 50%;
    padding-left: 40px;
  }
}
@media (max-width: 1024px) and (min-width: 768px) {
  .title {
    font-size: 18px;
    margin: 50px 0 15px 0;
  }
}
@media (max-width: 767px) and (min-width: 320px) {
  .title {
    font-size: 18px;
    margin: 50px 0 23px 0;
  }
  .location-box .location-item {
    width: 70px;
  }
  .cases-part2-box .title-p {
    margin-bottom: 25px;
  }
  .location-container {
    padding-right: 0;
  }
  .location-box {
    margin: 29px 0 50px 0;
  }
  .location-detail {
    margin-top: 30px;
    .detail-title {
      height: 35px;
      line-height: 35px;
    }
    .title-left {
      padding-left: 44px;
      font-size: 15px;
    }
    .title-right {
      padding-left: 21px;
      font-size: 15px;
    }
    .detail-list {
      font-size: 12px;
      .detail-list-item span {
        width: 42px;
      }
    }
    .detail-right {
      padding-left: 21px;
    }
  }
  .detail-container {
    padding-left: 0 !important;
  }
}
</style>
